import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import globalMU from "globalMU"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"

export type  DefinirDescricaoProdutoItemParams = {
    identificadorItem:number,
    descricao: string,
    atualizarEstadoLegadoImediatamente?: boolean
    itemOrcamentoLegado?: any
}


export async function definirDescricaoProdutoItem(params: DefinirDescricaoProdutoItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirDescricaoItem(
            params.identificadorItem, 
            store.getState().orcamento.IdentificadorOrcamento,
            params.descricao)

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)

    } finally {
        globalMU.unblockUI()
    }
}